<template>
    <div>
        <div class="row" v-if="apiStatus === null">
            <div class="col-12">
                <label class="font-weight-normal">
                {{ $t("nuevo email") }}
                <span class="required">*</span>
              </label>
                 <input type="email" class="form-control col-md-12 pl-2" :class="{ 'is-invalid' : valid.mail_a === false, 'is-valid' : valid.mail_a }" v-model="mail_a" />
            </div>  
            <div class="col-12">
                <label class="font-weight-normal">
                {{ $t("repita email") }}
                <span class="required">*</span>
              </label>
                <input type="email" class="form-control col-md-12 pl-2" :class="{ 'is-invalid' : valid.mail_b === false, 'is-valid' : valid.mail_b }" v-model="mail_b" />
            </div>
            <div class="col-12 mt-2" v-show="valid.mail_a && valid.mail_b">
                <button type="button" class="btn btn-danger btn-sm btn-block" @click="cambiarEmail">{{$t('actualizar')}}</button>
            </div>
           <!--  <div v-else class="col-12 mb-3">
                &nbsp;
            </div> -->
            
        </div>
        <div class="row" v-if="apiStatus">
            <div class="col-12">
                <p v-html="$t('texto peticion cambio email ok')"></p>
            </div>
            <div class="col-12 mt-2">
                <button type="button" class="btn btn-primary btn-sm btn-block" @click="$emit('emitCerrar')">{{$t('cerrar')}}</button>
            </div>
        </div>
        <div class="row" v-if="apiStatus === false">
            <div class="col-12">
                <p v-html="$t('texto peticion cambio email error')"></p>
                <div class="col-12 mt-2">
                <button type="button" class="btn btn-primary btn-sm btn-block" @click="$emit('emitCerrar')">{{$t('cerrar')}}</button>
            </div>
            </div>
        </div>

    </div>
</template>

<script>
import { mapActions } from "vuex";
    export default {
        name:"User-New-Mail",
        props:["currentMail"],
        data:() => ({
            mail_a: null,
            mail_b: null,
            valid: {
                mail_a: null,
                mail_b: null
            },
            apiStatus: null
        }),
        methods: {
            ...mapActions("usuario", ["actChangeUserMail"]),
            cambiarEmail() {

                const datos = {
                    user_url: new URL(location.href).origin,
                    mail_a: this.mail_a,
                    mail_b: this.mail_b
                }
                this.actChangeUserMail(datos).then(res => {
                    console.log(res);
                    this.apiStatus = res
                })
            }

        },
       watch: {
                mail_a: function (val) {
                    if (!val) return null;
                    this.valid.mail_a = validarEmail(val, this.currentMail);
                },
                mail_b: function (val) {
                    console.log(!val, !!val)
                     if (!val) return null;
                    this.valid.mail_b = validarEmail(val, this.currentMail) && this.mail_a === this.mail_b;
                }
        }
        
    }


    /* FUNCIONES */
    const validarEmail = (mail, currMail) => { 
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail) && currMail !== mail )
        {
            return (true)
        }
        
            return (false)
    }
</script>
<style scoped>
p {
   font-size:0.8em;
}
</style>